import CustomerPerformanceReducer from "./customer-performance";
import SalesPerformanceChartReducer from "./sales-performance";

export default  {
    customerPerformance:CustomerPerformanceReducer,
    salesPerformanceChart:SalesPerformanceChartReducer
}